import '../data/blog-styles.css';

const html = `
<div class="blog-content">
  <!-- 1. BlogPosting Schema -->
  <script type="application/ld+json">
  {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://mon-depannage-informatique.fr/blog/tarif-depannage-informatique-domicile-13-prix-2025"
    },
    "headline": "Tarif Dépannage Informatique à Domicile : 13 Prix 2025",
    "description": "Découvrez les 13 tarifs détaillés du dépannage informatique à domicile en 2025 : de 49€ à 179€ selon la prestation. Crédit d'impôt 50%, forfaits tout compris, garanties incluses.",
    "image": {
      "@type": "ImageObject",
      "url": "https://mon-depannage-informatique.fr/imagesposts/blog11/assistance-informatique-à-domicile-tarif-image-1.webp",
      "width": 800,
      "height": 450
    },
    "author": {
      "@type": "Person",
      "name": "Nicolas Fontaine"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Mon Dépannage Informatique",
      "url": "https://mon-depannage-informatique.fr",
      "logo": {
        "@type": "ImageObject",
        "url": "https://mon-depannage-informatique.fr/static/media/mon-depannage-informatique-logo.webp"
      }
    },
    "datePublished": "2025-10-26T10:00:00+01:00",
    "dateModified": "2025-10-26T10:00:00+01:00",
    "inLanguage": "fr-FR"
  }
  </script>

  <!-- 2. FAQPage Schema -->
  <script type="application/ld+json">
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Quel est le prix moyen d'une intervention à domicile en 2025 ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Le tarif horaire moyen s'établit à 60€ TTC, avec des variations de 45€ à 80€ selon votre région. Les forfaits intervention oscillent entre 49€ (paramétrage simple) et 179€ (transfert complet de données). Ces prix incluent généralement le déplacement dans un rayon de 15 kilomètres."
        }
      },
      {
        "@type": "Question",
        "name": "La première heure est-elle facturée différemment ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "La plupart des professionnels appliquent une facturation à l'heure entamée pour la première heure, puis au quart d'heure suivant. Certains proposent des forfaits de première intervention incluant diagnostic et réparation simple. Le diagnostic seul coûte entre 39€ et 59€, généralement déduit en cas d'intervention."
        }
      },
      {
        "@type": "Question",
        "name": "Les déplacements sont-ils toujours facturés en plus ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Les frais de déplacement dépendent de la distance et de la politique tarifaire du prestataire. Dans un rayon de 10 à 15 km, ils sont souvent inclus dans les forfaits. Au-delà, comptez 0,50€ à 0,70€ par kilomètre supplémentaire, conformément au barème fiscal des frais professionnels."
        }
      },
      {
        "@type": "Question",
        "name": "Quelles prestations sont éligibles au crédit d'impôt ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Toutes les interventions d'assistance informatique réalisées au domicile du particulier ouvrent droit à 50% de réduction d'impôt. Sont inclus : dépannage, installation, formation, maintenance préventive. Le prestataire doit posséder l'agrément service à la personne pour que vous bénéficiiez de cet avantage fiscal."
        }
      },
      {
        "@type": "Question",
        "name": "Existe-t-il des tarifs préférentiels pour les seniors ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Certains prestataires proposent des réductions de 10% à 15% aux personnes de plus de 65 ans. Les cours informatique seniors bénéficient souvent de tarifs dégressifs. Les caisses de retraite et l'APA peuvent également financer partiellement ces prestations."
        }
      }
    ]
  }
  </script>

  <!-- 3. BreadcrumbList Schema -->
  <script type="application/ld+json">
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Accueil",
        "item": "https://mon-depannage-informatique.fr"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Blog",
        "item": "https://mon-depannage-informatique.fr/blog"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Tarif Dépannage Informatique à Domicile : 13 Prix 2025",
        "item": "https://mon-depannage-informatique.fr/blog/tarif-depannage-informatique-domicile-13-prix-2025"
      }
    ]
  }
  </script>

  <div>

<h1>Tarif Dépannage Informatique à Domicile : 13 Prix 2025</h1>

<p><strong>Pas le temps de lire ? Ce qu'il faut savoir absolument :</strong>
<br>📌 Le tarif moyen horaire est de 60€ pour une intervention à domicile en 2025
<br>📌 Les forfaits tout compris varient de 89€ à 149€ selon la prestation
<br>📌 Les tarifs sont 50% déductibles des impôts (service à la personne)
<br>📌 Le diagnostic initial est souvent offert ou déduit en cas d'intervention
<br>📌 La garantie intervention est généralement de 30 jours minimum
</p>

<p>Vous cherchez une <strong>assistance informatique à domicile</strong> mais vous interrogez-vous sur les coûts réels ? Les tarifs du dépannage informatique varient considérablement selon votre région, le type d'intervention et la complexité du problème. En 2025, le marché propose des grilles tarifaires plus transparentes, avec des forfaits adaptés à chaque besoin.</p>

<p>Combien coûte réellement un dépannage informatique chez vous ? Quels sont les facteurs qui influencent le prix final ? Comment optimiser votre budget tout en bénéficiant d'un service de qualité ? Cet article vous présente 13 tarifs détaillés et vous aide à comprendre la structure des prix pratiqués par les professionnels.</p>

<h2>Sommaire</h2>
<ol>
    <li><a href="#section-1">Grille tarifaire complète des interventions 2025</a></li>
    <li><a href="#section-2">Facteurs influençant le prix du dépannage</a></li>
    <li><a href="#section-3">Comparatif des formules et forfaits disponibles</a></li>
    <li><a href="#section-4">Avantages fiscaux et aides financières</a></li>
    <li><a href="#section-5">Garanties et assurances professionnelles</a></li>
</ol>

<img src="/imagesposts/blog11/assistance-informatique-à-domicile-tarif-image-1.webp" alt="assistance informatique à domicile tarif - grille tarifaire complète avec technicien professionnel intervenant chez un particulier" title="Grille tarifaire complète pour l'assistance informatique à domicile en 2025" loading="lazy" width="800" height="450">

<h2 id="section-1">Grille tarifaire complète des interventions 2025</h2>

<p>Quels sont les prix pratiqués pour chaque type d'intervention ? La tarification du <strong>dépannage informatique à domicile</strong> suit une logique précise basée sur la complexité technique et le temps nécessaire. Voici les 13 tarifs de référence pour l'année 2025.</p>

<h3 id="sous-section-1-1">Tarifs horaires par zone géographique</h3>

<p>Pourquoi les prix varient-ils selon votre localisation ? Les tarifs de l'<strong>assistance informatique à domicile</strong> dépendent principalement du coût de la vie local et de la densité de techniciens disponibles. Pour comprendre en détail <a href="/blog/combien-coute-assistance-informatique-domicile">combien coûte réellement une assistance informatique à domicile</a>, consultez notre analyse complète des facteurs de prix.</p>

<ul>
<li><strong>Île-de-France</strong> : 65€ à 80€ de l'heure</li>
<li><strong>Métropoles régionales</strong> (Lyon, Marseille, Toulouse) : 55€ à 70€ de l'heure</li>
<li><strong>Villes moyennes</strong> : 50€ à 65€ de l'heure</li>
<li><strong>Zones rurales</strong> : 45€ à 60€ de l'heure</li>
</ul>

<p>Les frais de déplacement s'ajoutent généralement au tarif horaire. Ils oscillent entre 0,50€ et 0,70€ par kilomètre selon l'article 83 du Code général des impôts pour les prestations de service à la personne.</p>

<h3 id="sous-section-1-2">Forfaits intervention courante</h3>

<p>Comment fonctionnent les forfaits pour les interventions standards ? La plupart des professionnels proposent des forfaits tout compris pour les prestations les plus demandées. Cette approche vous garantit une transparence tarifaire totale.</p>

<table>
    <thead>
        <tr>
            <th>Type d'intervention</th>
            <th>Durée moyenne</th>
            <th>Tarif TTC</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>Diagnostic et nettoyage système</td>
            <td>1h30</td>
            <td>89€</td>
        </tr>
        <tr>
            <td>Installation logiciels bureautiques</td>
            <td>2h</td>
            <td>119€</td>
        </tr>
        <tr>
            <td>Configuration réseau Wi-Fi</td>
            <td>1h</td>
            <td>79€</td>
        </tr>
        <tr>
            <td>Sauvegarde et récupération données</td>
            <td>2h30</td>
            <td>149€</td>
        </tr>
        <tr>
            <td>Formation utilisateur personnalisée</td>
            <td>2h</td>
            <td>109€</td>
        </tr>
        <tr>
            <td>Suppression virus et malwares</td>
            <td>1h45</td>
            <td>99€</td>
        </tr>
        <tr>
            <td>Mise à jour et optimisation</td>
            <td>1h15</td>
            <td>69€</td>
        </tr>
        <tr>
            <td>Installation imprimante/scanner</td>
            <td>45min</td>
            <td>59€</td>
        </tr>
        <tr>
            <td>Paramétrage messagerie électronique</td>
            <td>30min</td>
            <td>49€</td>
        </tr>
        <tr>
            <td>Transfert données ancien/nouvel ordinateur</td>
            <td>3h</td>
            <td>179€</td>
        </tr>
        <tr>
            <td>Réparation système d'exploitation</td>
            <td>2h15</td>
            <td>139€</td>
        </tr>
        <tr>
            <td>Configuration sécurité et antivirus</td>
            <td>1h</td>
            <td>79€</td>
        </tr>
        <tr>
            <td>Dépannage urgence week-end</td>
            <td>Variable</td>
            <td>+30% du tarif</td>
        </tr>
    </tbody>
</table>

<p>Ces tarifs incluent le diagnostic, l'intervention technique et une garantie de 30 jours minimum. Le déplacement dans un rayon de 15 kilomètres est généralement inclus dans ces forfaits.</p>

<h2 id="section-2">Facteurs influençant le prix du dépannage</h2>

<p>Quels éléments déterminent le coût final de votre intervention ? Plusieurs critères influencent directement le <strong>tarif dépannage informatique à domicile</strong>. Comprendre ces facteurs vous aide à mieux anticiper votre budget.</p>

<h3 id="sous-section-2-1">Critères techniques et matériels</h3>

<p>La complexité technique de votre problème représente le premier facteur tarifaire. Un simple paramétrage ne nécessite pas les mêmes compétences qu'une récupération de données sur disque dur défaillant.</p>

<ul>
<li><strong>Niveau de complexité</strong> : Les interventions simples (installation logiciel) coûtent moins cher que les réparations système complexes</li>
<li><strong>Matériel concerné</strong> : PC de bureau, ordinateur portable, tablette ou smartphone requièrent des approches différentes</li>
<li><strong>Système d'exploitation</strong> : Windows, macOS ou Linux impliquent des expertises spécialisées</li>
<li><strong>Ancienneté du matériel</strong> : Les machines anciennes demandent souvent plus de temps d'intervention</li>
</ul>

<p>Avez-vous besoin de pièces de rechange ? Le coût des composants s'ajoute au tarif d'intervention. Les professionnels appliquent généralement une marge de 20% à 30% sur les pièces détachées selon l'article L441-6 du Code de commerce.</p>

<h3 id="sous-section-2-2">Variables géographiques et temporelles</h3>

<p>Votre localisation et le moment de l'intervention influencent significativement le prix final. Ces variables reflètent les contraintes logistiques du technicien.</p>

<ul>
<li><strong>Distance du déplacement</strong> : Au-delà de 15 km, comptez 0,50€ à 0,70€ par kilomètre supplémentaire</li>
<li><strong>Accessibilité du domicile</strong> : Les étages sans ascenseur ou parkings difficiles peuvent majorer le tarif</li>
<li><strong>Créneaux horaires</strong> : Les interventions en soirée (après 18h) coûtent 15% à 20% plus cher</li>
<li><strong>Week-ends et jours fériés</strong> : Majorations de 25% à 50% selon l'urgence</li>
</ul>

<img src="/imagesposts/blog11/assistance-informatique-à-domicile-tarif-image-2.webp" alt="assistance informatique à domicile tarif - comparatif détaillé des prix par région avec carte interactive" title="Comparatif régional des tarifs d'assistance informatique à domicile" loading="lazy" width="800" height="450">

<h2 id="section-3">Comparatif des formules et forfaits disponibles</h2>

<p>Comment choisir entre un forfait et une facturation horaire ? Les professionnels de l'<strong>aide informatique à domicile</strong> proposent différentes formules adaptées à vos besoins spécifiques. Analysons les avantages de chaque approche.</p>

<h3 id="sous-section-3-1">Forfaits tout compris</h3>

<p>Les forfaits présentent l'avantage d'une transparence tarifaire totale. Vous connaissez le prix exact avant l'intervention, sans surprise sur la facture finale.</p>

<table>
    <thead>
        <tr>
            <th>Formule</th>
            <th>Services inclus</th>
            <th>Prix forfaitaire</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>Forfait Express</td>
            <td>Diagnostic + une intervention simple + déplacement 10 km</td>
            <td>79€</td>
        </tr>
        <tr>
            <td>Forfait Confort</td>
            <td>Diagnostic + intervention complète + formation + garantie 60 jours</td>
            <td>129€</td>
        </tr>
        <tr>
            <td>Forfait Premium</td>
            <td>Diagnostic + intervention + formation + suivi téléphonique 3 mois</td>
            <td>199€</td>
        </tr>
    </tbody>
</table>

<p>Quand privilégier la facturation horaire ? Cette option convient mieux pour les problèmes complexes ou les interventions dont la durée reste difficile à estimer. Le tarif horaire moyen national s'établit à 60€ TTC en 2025.</p>

<p>Les avantages de chaque formule dépendent de votre situation. Pour une <strong>réparation ordinateur à proximité</strong> simple, le forfait Express suffit généralement. Les utilisateurs seniors apprécient souvent le forfait Premium incluant un accompagnement prolongé. Découvrez nos <a href="/blog/astuces-economiques-depannage-pc-proximite-tarifs">5 astuces économiques pour optimiser votre budget dépannage PC</a>.</p>

<h2 id="section-4">Avantages fiscaux et aides financières</h2>

<p>Saviez-vous que votre <strong>dépannage informatique autour de moi</strong> peut vous faire économiser sur vos impôts ? Les prestations d'assistance informatique à domicile bénéficient d'avantages fiscaux substantiels grâce au régime des services à la personne.</p>

<h3 id="sous-section-4-1">Crédit d'impôt service à la personne</h3>

<p>Comment fonctionne cette réduction fiscale ? L'article 199 sexdecies du Code général des impôts autorise une réduction d'impôt de 50% des sommes versées pour les services à la personne, dans la limite de 12 000€ par an.</p>

<ul>
<li><strong>Taux de réduction</strong> : 50% des sommes payées</li>
<li><strong>Plafond annuel</strong> : 12 000€ de dépenses déductibles</li>
<li><strong>Économie maximale</strong> : 6 000€ d'impôt en moins par an</li>
<li><strong>Majoration famille nombreuse</strong> : +1 500€ de plafond par enfant à charge à partir du 3ème</li>
</ul>

<p>Quelles prestations sont éligibles ? L'assistance informatique à domicile entre dans le champ des services à la personne selon l'arrêté du 26 décembre 2005. Sont concernées toutes les interventions techniques réalisées au domicile du particulier.</p>

<h3 id="sous-section-4-2">Aides spécifiques seniors et PMR</h3>

<p>Des dispositifs spéciaux existent-ils pour les personnes âgées ? Plusieurs organismes proposent des aides financières pour faciliter l'accès au numérique des seniors et des personnes à mobilité réduite. Consultez notre guide complet sur l'<a href="/blog/assistance-informatique-senior-domicile-vrais-tarifs-2025">assistance informatique senior à domicile avec les vrais tarifs 2025</a> et toutes les aides cumulables.</p>

<ul>
<li><strong>Chèque emploi service universel</strong> (CESU) : Accepté par la plupart des prestataires</li>
<li><strong>Aide des caisses de retraite</strong> : Jusqu'à 3 500€ par an pour l'aide au maintien à domicile</li>
<li><strong>Allocation personnalisée d'autonomie</strong> (APA) : Peut financer l'assistance informatique</li>
<li><strong>Aides départementales</strong> : Variables selon votre lieu de résidence</li>
</ul>

<p>Comment bénéficier de ces avantages ? Vérifiez que votre prestataire possède l'agrément service à la personne délivré par la DIRECCTE. Cette certification garantit votre éligibilité aux réductions fiscales.</p>

<h2 id="section-5">Garanties et assurances professionnelles</h2>

<p>Quelles protections vous couvrent lors d'une intervention à domicile ? Un prestataire sérieux propose systématiquement des garanties étendues et dispose d'assurances professionnelles couvrant ses interventions.</p>

<h3 id="sous-section-5-1">Conditions de garantie intervention</h3>

<p>Que couvre exactement la garantie intervention ? Cette protection vous assure une reprise gratuite en cas de dysfonctionnement lié à l'intervention réalisée.</p>

<ul>
<li><strong>Durée standard</strong> : 30 jours minimum après intervention</li>
<li><strong>Garantie étendue</strong> : Jusqu'à 90 jours chez certains prestataires</li>
<li><strong>Périmètre couvert</strong> : Reprise gratuite des opérations défaillantes</li>
<li><strong>Exclusions habituelles</strong> : Pannes matérielles, virus contractés après intervention, fausses manipulations</li>
</ul>

<p>La garantie pièces suit-elle les mêmes règles ? Les composants installés bénéficient de la garantie constructeur, généralement comprise entre 1 et 3 ans selon l'article L217-7 du Code de la consommation.</p>

<h3 id="sous-section-5-2">Assurances et certifications</h3>

<p>Comment vérifier les qualifications de votre technicien ? Plusieurs certifications attestent du professionnalisme et de la formation continue des intervenants en <strong>aide informatique senior à domicile</strong>.</p>

<ul>
<li><strong>Assurance responsabilité civile professionnelle</strong> : Obligatoire, couvre les dommages causés chez vous</li>
<li><strong>Assurance décennale</strong> : Recommandée pour les installations permanentes</li>
<li><strong>Certification AFNOR</strong> : Gage de qualité des processus</li>
<li><strong>Agrément services à la personne</strong> : Indispensable pour les avantages fiscaux</li>
</ul>

<p>Quels documents exiger avant intervention ? Demandez systématiquement l'attestation d'assurance en cours de validité et le numéro d'agrément service à la personne. Ces pièces vous protègent juridiquement.</p>

<h2>🧠 Mini FAQ pour les pressés</h2>

<h3>Quel est le prix moyen d'une intervention à domicile en 2025 ?</h3>
<p>Le tarif horaire moyen s'établit à 60€ TTC, avec des variations de 45€ à 80€ selon votre région. Les forfaits intervention oscillent entre 49€ (paramétrage simple) et 179€ (transfert complet de données). Ces prix incluent généralement le déplacement dans un rayon de 15 kilomètres.</p>

<h3>La première heure est-elle facturée différemment ?</h3>
<p>La plupart des professionnels appliquent une facturation à l'heure entamée pour la première heure, puis au quart d'heure suivant. Certains proposent des forfaits de première intervention incluant diagnostic et réparation simple. Le diagnostic seul coûte entre 39€ et 59€, généralement déduit en cas d'intervention.</p>

<h3>Les déplacements sont-ils toujours facturés en plus ?</h3>
<p>Les frais de déplacement dépendent de la distance et de la politique tarifaire du prestataire. Dans un rayon de 10 à 15 km, ils sont souvent inclus dans les forfaits. Au-delà, comptez 0,50€ à 0,70€ par kilomètre supplémentaire, conformément au barème fiscal des frais professionnels.</p>

<h3>Quelles prestations sont éligibles au crédit d'impôt ?</h3>
<p>Toutes les interventions d'assistance informatique réalisées au domicile du particulier ouvrent droit à 50% de réduction d'impôt. Sont inclus : dépannage, installation, formation, maintenance préventive. Le prestataire doit posséder l'agrément service à la personne pour que vous bénéficiiez de cet avantage fiscal.</p>

<h3>Existe-t-il des tarifs préférentiels pour les seniors ?</h3>
<p>Certains prestataires proposent des réductions de 10% à 15% aux personnes de plus de 65 ans. Les <strong>cours informatique seniors</strong> bénéficient souvent de tarifs dégressifs. Les caisses de retraite et l'APA peuvent également financer partiellement ces prestations. Renseignez-vous auprès de votre caisse de retraite sur les aides disponibles.</p>

<p>Vous disposez maintenant d'une vision complète des tarifs pratiqués en 2025 pour l'<strong>assistance informatique à domicile</strong>. N'hésitez pas à demander plusieurs devis détaillés pour comparer les prestations incluses. Privilégiez les prestataires agréés services à la personne pour bénéficier des avantages fiscaux et d'une protection optimale. Pour obtenir un <a href="/blog/assistance-informatique-domicile-tarifs-devis-rapide">devis rapide et personnalisé sous 24h</a>, suivez notre guide pratique.</p>

<div class="cta-section" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 30px; border-radius: 10px; margin: 40px 0; text-align: center; color: white;">
  <h3 style="color: white; margin-top: 0;">Intervention à domicile sous 48h</h3>
  <p style="font-size: 1.1em; margin: 20px 0;">Technicien certifié, tarifs transparents et crédit d'impôt de 50%. Dépannage rapide garanti.</p>
  <a href="/reparation-domicile" style="display: inline-block; background: white; color: #667eea; padding: 15px 40px; border-radius: 50px; font-weight: bold; text-decoration: none; font-size: 1.1em; transition: transform 0.3s;">
    Réserver mon dépannage
  </a>
</div>

<div class="related-articles" style="background-color: #f8f9fa; padding: 25px; border-left: 4px solid #007bff; margin: 30px 0;">
  <h3 style="color: #007bff; margin-top: 0;">Articles connexes recommandés</h3>
  <ul style="list-style: none; padding: 0;">
    <li style="margin-bottom: 15px;">
      <a href="/blog/quel-tarif-depannage-informatique-7-prix-reels-2025" style="font-weight: bold; color: #0056b3; text-decoration: none;">→ Quel Tarif pour un Dépannage Informatique ? 7 Prix Réels 2025</a>
      <p style="margin: 5px 0 0 20px; color: #666; font-size: 0.95em;">Analyse comparative des tarifs avec grille complète et majorations par créneau horaire.</p>
    </li>
    <li style="margin-bottom: 15px;">
      <a href="/blog/combien-coute-assistance-informatique-domicile" style="font-weight: bold; color: #0056b3; text-decoration: none;">→ Combien Coûte une Assistance Informatique à Domicile ?</a>
      <p style="margin: 5px 0 0 20px; color: #666; font-size: 0.95em;">Guide détaillé des coûts réels avec crédit d'impôt 50% et forfaits déplacement.</p>
    </li>
    <li style="margin-bottom: 15px;">
      <a href="/blog/assistance-informatique-domicile-tarifs-devis-rapide" style="font-weight: bold; color: #0056b3; text-decoration: none;">→ Assistance Informatique à Domicile : Tarifs & Devis Rapide</a>
      <p style="margin: 5px 0 0 20px; color: #666; font-size: 0.95em;">Obtenez votre devis personnalisé sous 24h avec grille tarifaire détaillée par prestation.</p>
    </li>
    <li style="margin-bottom: 15px;">
      <a href="/blog/astuces-economiques-depannage-pc-proximite-tarifs" style="font-weight: bold; color: #0056b3; text-decoration: none;">→ 5 Astuces Économiques Dépannage PC à Proximité</a>
      <p style="margin: 5px 0 0 20px; color: #666; font-size: 0.95em;">Techniques éprouvées pour réduire vos coûts de dépannage de 30% à 50%.</p>
    </li>
  </ul>
</div>

  </div>
</div>
`;

export const blogMeta = {
  id: "tarif-depannage-informatique-domicile-13-prix-2025",
  slug: "tarif-depannage-informatique-domicile-13-prix-2025",
  title: "Tarif Dépannage Informatique à Domicile : 13 Prix 2025",
  description: "Découvrez les 13 tarifs détaillés du dépannage informatique à domicile en 2025 : de 49€ à 179€ selon la prestation. Crédit d'impôt 50%, forfaits tout compris, garanties incluses.",
  date: "26 Octobre 2025",
  category: "Tarifs et Services",
  image: "/imagesposts/blog11/assistance-informatique-à-domicile-tarif-image-1.webp",
  author: "Nicolas Fontaine",
  publishedAt: "26 octobre 2025, 10 h 00",
  readingTime: "12 minutes de lecture",
  url: "/blog/tarif-depannage-informatique-domicile-13-prix-2025",
  html
};
